export enum RATE_CARD_COLUMN_NAME {
  RATE_CARD_NAME = "ratecardName",
  RATE_CARD_TYPE = "ratecardType",
  ASSOCIATED_STORE = "associatedStore",
  NUMBER_OF_INVOICES_GENERATED = "invoiceCount",
  LAST_INVOICE_CREATED_DATE = "lastInvoiceDate",
  ACTIVE = "isActive",
  CREATED_ON = "createdOn",
  UPDATED_ON = "updatedOn",
}

export enum RATE_CARD_LABEL_NAME {
  RATE_CARD_NAME = "Rate Card Name",
  RATE_CARD_TYPE = "Rate Card Type",
  ASSOCIATED_STORE = "Associated Store",
  NUMBER_OF_INVOICES_GENERATED = "Number Of Invoices Generated",
  LAST_INVOICE_CREATED_DATE = "Last Invoice Created Date",
  ACTIVE = "Active",
  CREATED_ON = "Created On",
  UPDATED_ON = "Updated On",
}

export const RATE_CARD_TYPES = ["route_rate", "package_rate", "flat_rate"];
export const PRICE_PER_PACKAGE_TYPES = ["per_route", "per_package"];

export const CUSTOM_FIELD_APPLICABLE_FOR_TYPES = ["FDC", "FDP", "BOTH"];

export const VARIABLE_RATE_TYPES = ["package", "mile", "stop"];
export const LATE_CANCELLATION_TYPES = ["per_route", "per_package"];
export const FUEL_TYPES = ["petrol", "diesel"];

export const DISOUNT_RATE_TYPES = ["base_rate", "total_revenue"];

export const FUEL_SURCHARGE_FIELD_TYPES = [
  "base_rate",
  "variable_rate",
  "route_minimum",
  "total_revenue",
];
